var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{attrs:{"id":_vm.id,"modal-class":"common-modal"},on:{"hidden":_vm.handleModal}},[_c('div',{staticStyle:{"color":"#3F4C5C","text-align":"center"},domProps:{"innerHTML":_vm._s(_vm.msg)}})])}
var staticRenderFns = []

export { render, staticRenderFns }